import React from 'react';
import {
  ModalBody,
  Text,
  Flex,
  Button,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
} from '@chakra-ui/react';
import ClientInfo from './ClientInfo';
import VehicleDetails from './VehicleDetails';
import ServiceDetails from './ServiceDetails';

const ClientDetailModal = ({ clientData, vehicles, services, onClose, onAddService }) => {
  return (
    <>
      <ModalBody>
        <Flex direction="column" p="4">
          <Text fontSize="lg" fontWeight="bold">
            Detalles del Cliente
          </Text>
          <Tabs mt="4" variant="enclosed">
            <TabList>
              <Tab>Información General</Tab>
              <Tab>Vehículos Asociados</Tab>
              <Tab>Historial de servicios del Cliente</Tab>
            </TabList>

            <TabPanels>
              <TabPanel>
                <ClientInfo clientData={clientData} />
              </TabPanel>

              <TabPanel>
                <VehicleDetails vehicles={vehicles} onAddService={onAddService || (() => {})} />
              </TabPanel>

              <TabPanel>
                <ServiceDetails services={services} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Flex>
        <Button mt={4} onClick={onClose}>
          Cerrar
        </Button>
      </ModalBody>
    </>
  );
};

export default ClientDetailModal;